import type { DlsgPolicy } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  StorageGatewayWizardFlow,
  type StorageGatewayWizardState,
} from './storageGatewayWizardFlow';

export const StorageGatewayWizard = ({
  onSave,
  onClose,
  entity,
}: {
  onSave: () => Promise<void>;
  onClose: () => void;
  entity: DlsgPolicy;
}) => {
  return (
    <Wizard<StorageGatewayWizardState>
      hideBackArrow={true}
      onAbort={onClose}
      onFinish={async () => {
        await onSave();
        return true;
      }}
      flow={[StorageGatewayWizardFlow]}
      initialState={entity}
      title='Connect resources to Gateway'
    />
  );
};
